export class CreateLimiteProduit
{
    limiteAutorise: number;
    produitId:number;
}